import { TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutCollectionsProfileList } from "./autogen/AutogenLayoutCollectionsProfileList";

export class CollectionsProfileList extends AutogenLayoutCollectionsProfileList {
    override onLoad() {
        this.mainDataSource.search();
    }

    tableCollectionsProfileOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const imageProfileColor = tableRow.findComponentById("imageProfileColor");
        if (imageProfileColor != null) {
            const profileColor = tableRow.data?.getString("profile_color", null) as string;
            imageProfileColor.color = profileColor;
            imageProfileColor.visible = profileColor != null;
        }
    }
}
